import { render, staticRenderFns } from "./epb-virtual-scroller-sortable-list.component.vue?vue&type=template&id=297052b4"
import script from "./epb-virtual-scroller-sortable-list.component.vue?vue&type=script&lang=ts"
export * from "./epb-virtual-scroller-sortable-list.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports